import styled from "styled-components";

export const Container = styled.div`
	display: flex;

	width: 100%;
	height: 100%;

	font-family: "Mulish";

	.blur {
		display: flex;

		position: absolute;

		justify-content: center;
		align-items: center;

		width: 100vw;
		height: 100vh;

		background-color: rgba(255, 255, 255, 0.5);
		backdrop-filter: blur(8px);
	}

	.login-container {
		display: flex;
		flex-direction: column;

		padding: 3rem;

		width: 30rem;

		background-color: white;

		border-radius: 0.25rem;

		box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.3);

		.container-header {
			display: flex;
			flex-direction: column;

			height: 40%;

			img {
				height: 10rem;
				margin-bottom: 1rem;
			}

			#title {
				color: #47516a;

				font-size: 1.3rem;
				font-weight: bold;
			}

			#sub-title {
				color: #c0c4df;

				font-size: 1rem;
			}
		}

		.input-wrapper {
			display: flex;
			flex-direction: column;

			height: 30%;

			margin-top: 2rem;

			align-items: center;
			justify-content: center;

			gap: 1rem;
		}

		.input-wrapper > input {
			width: 100%;
			height: 3rem;

			font-size: 1rem;

			border: 1px solid #c0c4df;
			border-radius: 0.2em;

			padding-left: 0.8rem;

			transition: all 0.2s;
			color: #c0c4df;

			::placeholder {
				color: #c0c4df;
			}
		}

		.input-wrapper > input:focus {
			border: 1px solid #2d7bbc;
			color: #2d7bbc;

			::placeholder {
				color: #2d7bbc;
			}
		}

		.input-wrapper > input.error {
			border: 1px solid red;
			color: red;

			::placeholder {
				color: red;
			}
		}

		.container-bottom {
			display: flex;
			flex-direction: column;

			margin-top: 1rem;

			justify-content: flex-start;
		}

		.container-bottom > div {
			display: flex;

			justify-content: space-between;
		}

		.checkbox-wrapper {
			display: flex;

			gap: 0.3rem;

			align-items: center;
		}

		.container-bottom > div > a {
			border: none;
			background: none;

			color: #2d7bbc;

			cursor: pointer;
		}

		.container-bottom > button {
			width: 100%;
			height: 3.5rem;

			transition: all 0.1s;

			font-size: 1.4rem;

			border: 1px #2d7bbc solid;
			border-radius: 0.5rem;

			color: #2d7bbc;

			margin-top: 2rem;

			cursor: pointer;
		}

		.container-bottom > button:hover {
			background-color: #2d7bbc;
			color: white;
		}
	}
`;
